import axiosHandler from '../axiosInterceptors';
import { FETCH_PRODUCT_DATA, CREATE_PRODUCT_DATA, UPDATE_PRODUCT_DATA, DELETE_PRODUCT_DATA, FETCH_PRODUCT_GLOBAL_SEARCH_DATA, FETCH_PRODUCT_SEARCH_DATA, FETCH_PID, PUBLISH_PRODUCT_DCL, UPDATE_PRODUCT_DCL, DELETE_PRODUCT_DCL, FETCH_VID_FOR_PRODUCT } from '../constants/urls';
import setAuthHeader from './AuthHeader';
// Call the setAuthHeader function to set the Authorization header
setAuthHeader();

export async function fetchProductData() {
    try{
        const resp = await axiosHandler.get(FETCH_PRODUCT_DATA);
        return resp;
    }
    catch(error){
        throw error.response.data;
    }
}

export async function createProductData(data) {
    try{
        const resp = await axiosHandler.post(CREATE_PRODUCT_DATA, data);
        return resp;
    }
    catch(error){
        throw error.response.data;
    }
}

export async function updateProductData(data) {
    try{
        const resp = await axiosHandler.patch(UPDATE_PRODUCT_DATA, data);
        return resp;
    }
    catch(error){
        throw error.response.data
    }
}

export async function deleteProductData(data) {
    try{
        const resp = await axiosHandler.delete(DELETE_PRODUCT_DATA + `?id=${data.id}`);
        return resp;
    }
    catch(error){
        throw error.response.data
    }
}

export async function fetchProductGlobalSearchData(data) {
    try{
        const resp = await axiosHandler.post(FETCH_PRODUCT_GLOBAL_SEARCH_DATA, data);
        return resp;
    }
    catch(error){
        throw error.response.data
    }
}

export async function searchProductData(data) {
    try{
        const resp = await axiosHandler.post(FETCH_PRODUCT_SEARCH_DATA, data);
        return resp;
    }
    catch(error){
        throw error.response.data
    }
}

export async function fetchPIDDropdownOption() {
    try{
        const resp = await axiosHandler.get(FETCH_PID);
        return resp;
    }
    catch(error){
        throw error.response.data
    }
}

export async function publishProductDCL(data, source) {
    try{
        const resp = await axiosHandler.post(PUBLISH_PRODUCT_DCL + `?source=${source}`, data);
        return resp;
    }
    catch(error){
        throw error.response.data
    }
}

export async function updateProductDCL(data, source) {
    try{
        const resp = await axiosHandler.patch(UPDATE_PRODUCT_DCL + `?source=${source}`, data);
        return resp;
    }
    catch(error){
        throw error.response.data
    }
}

export async function deleteProductDCL(data, source) {
    try{
        const resp = await axiosHandler.post(DELETE_PRODUCT_DCL + `?source=${source}`, data);
        return resp;
    }
    catch(error){
        throw error.response.data
    }
}

export async function fetchVidForPid(data) {    
    try{
        const resp = await axiosHandler.post(FETCH_VID_FOR_PRODUCT, data);
        return resp;
    }
    catch(error){
        throw error.response.data
    }
}


